
const state = {
  folio: null,
  billItems: [],
  billClient:  null,
  clientFullName: null,
  billData: null,
  showBillModal: false,
  showNewClientModal: false,
  billPaymentStatus: {
    name: '',
    type: ''
  },
  isValid: false,
};

const getters = {
  billIsValid: state => state.isValid,
  billModal: state => state.showBillModal,
  newClientModal: state => state.showNewClientModal,
  billSum: state => {
    let sum = 0;
    if(state.billItems){
      state.billItems.forEach(item => {
        sum += Number(item.total);
      });
    }
    return sum.toFixed(2);
  },
  billClientData: state => state.billClient ? Object.assign(state.billClient):null,
  billPaymentStatus: state => state.billPaymentStatus,
  billItems: state => state.billItems,
  nextFolio: state => state.folio
};

const mutations = {
  mSetBillValidStatus: (state, isValid) =>  state.isValid = isValid,
  mSetBillPaymentStatus: (state, payload)=> state.billPaymentStatus = payload,
  resetPaymentStatus: state => state.billPaymentStatus = {type:'', name: ''},
  setBillModalShowState: (state, payload) => state.showBillModal = payload,
  setNewClientModalShowState: (state, payload) => state.showNewClientModal = payload,
  mSetBillClientData: (state, data)=> state.billClient = data? Object.assign(data):null,
  addSingleBillItem: (state, item)=>{
    
    if (state.billItems.length>0) {
      const found = state.billItems.find(currItem => (currItem.id == item.id && currItem.codigo == item.codigo) );
      if(found) {
        found.cantidad = found.cantidad +1;
        found.minimo = item.minimo;
        found.total = (Number(found.precio) * Number(found.cantidad)).toFixed(2);
      }        
      else{
        state.billItems.push({
          id: item.id, 
          id_categoria: item.idCategoria,
          codigo: item.codigo, 
          unidad: item.unidad,
          descripcion: item.descripcion, 
          cantidad: item.minimo, 
          minimo: item.minimo,
          precio: Number(item.precio_venta).toFixed(2),
          total: Number((item.precio_venta * item.minimo)).toFixed(2)
        });
      }   
    }
    else{
      state.billItems.push({
        "id": item.id, 
        "id_categoria": item.idCategoria,
        "codigo": item.codigo, 
        "unidad": item.unidad,
        "minimo": item.minimo,
        "descripcion": item.descripcion, 
        "precio": Number(item.precio_venta).toFixed(2),
        "total": Number((item.precio_venta * item.minimo)).toFixed(2),
        "cantidad": item.minimo
      }); 
    }
  },
  setAllBillItems: (state, newItems)=>{
    state.billItems = newItems;
  },
  removeSingleItem: (state, codigoItem)=>{
    state.billItems = state.billItems.filter(item => item.codigo !== codigoItem);
  },
  updateItem: (state, item)=>{
    const found = state.billItems.find(currItem =>(currItem.id == item.id && currItem.codigo == item.codigo));
    found.total = (item.precio * item.cantidad).toFixed(2);
  },
  deleteBillItems: state =>{
    state.billItems = [];
  },
  deleteBillClient: state =>{
    state.billClient =  null;
    state.billClientFullName = null;
  },
  setNewFolio: (state, newFolio) => state.folio = newFolio//(lastInsertedSalesFolio() +1)
};

const actions = {
  setBillValidStatus: ({commit}, payload)=>{
    commit('mSetBillValidStatus', payload);
  },
  setBillPaymentStatus: ({commit}, payload)=>{
    commit('mSetBillPaymentStatus',payload);
  },
  resetBillPaymentStatus: ({commit})=>{
    commit('resetPaymentStatus');
  },
  toggleBillModal: ({commit}, payload)=>{
    commit('setBillModalShowState', payload);
  },
  toggleNewClientModal: ({commit}, payload)=>{
    commit('setNewClientModalShowState', payload);
  },
  setBillClientData: ({commit}, payload)=>{
    commit('mSetBillClientData', payload);
  },
  addBillItem: ({commit}, payload)=>{
    commit('addSingleBillItem', payload );
  },
  increaseItemQuantity: ({ commit }, payload)=>{
    commit('updateItem', payload);
  },
  removeItem: ({commit}, codigoItem)=>{
    commit('removeSingleItem', codigoItem);
  },
  setBillItems: ({commit}, newItems)=>{
    commit('setAllBillItems', newItems)
  },
  clearBillItems: ({commit})=>{
    commit('deleteBillItems');
  },
  clearBillClient: ({commit})=>{
    commit('deleteBillClient');
  },
  requestNewFolio: ({commit}, newFolio)=>{
    commit('setNewFolio', newFolio);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};